import { FailedPaymentTokenResponse, PaymentTokenResponse, SuccessfulPaymentTokenResponse } from "types/PaymentResponse";


export const parseIFrameEvent:(event: MessageEvent, iFrameUrl:string)=>{
  eventType:'success'|'failure'|'',
  token: string,
  code:string,
  reason:string
} = (event: MessageEvent, iFrameUrl:string) => {
  let eventType: 'success' | 'failure' | '' = '';
  let token = '';
  let code = '';
  let reason = ''; 

  const iframeOrigin = new URL(iFrameUrl).origin;

  // The origin here is used during testing to get arount
  // the annoying issue where isTrusted can't be set 
  // in mock data.  
  if( (event.isTrusted || event.origin === 'https://testurl.nothing')
       && event.origin === iframeOrigin
  ) {
    
        let response: PaymentTokenResponse | undefined;
        if(typeof event.data === 'string')
        {
          response = JSON.parse(event.data);
        }
          
        if (
          (response as SuccessfulPaymentTokenResponse)?.success 
          && (response as SuccessfulPaymentTokenResponse).token) {
          eventType = 'success';
          token = (response as SuccessfulPaymentTokenResponse).token; 
        } else if (
          (response as FailedPaymentTokenResponse)?.success === false 
          && ((response as FailedPaymentTokenResponse)?.code || (response as FailedPaymentTokenResponse)?.reason)) {
          eventType = 'failure';
          code = (response as FailedPaymentTokenResponse).code;
          reason = (response as FailedPaymentTokenResponse).reason;  
        } 
    }
    
    return {eventType, token, code, reason};
};